import axios from 'axios';
import { Tag, TagForm } from 'core/models';

export function getTags() {
    return axios.get<Tag[]>('/tags/');
}

export function getTag(id: number) {
    return axios.get<Tag>(`/tags/${id}/`);
}

export function createTag(tag: TagForm) {
    return axios.post('/tags/', tag);
}

export function editTag(id: number, tag: TagForm) {
    return axios.put(`/tags/edit/${id}/`, tag);
}

export function deleteTag(id: number) {
    return axios.delete(`/tags/remove/${id}/`);
}
